export default {
  name: 'Legend',
  props: ['emission', 'vehicleType'],
  methods: {
    getSteps(vehicleType, emission) {
      const legend = this.legends.filter(legend => legend.type === vehicleType)[0]
      if (!legend) return null
      return legend[this.emission].steps
    },
    getColor(vehicleType, index) {
      const legend = this.legends.filter(legend => legend.type === vehicleType)[0]
      if (!legend) return null
      return legend[this.emission].colors[index]
    }
  },
  data() {
    return {
      legends: [
        {
          type: 'LD',
          attributes: ['co2_gs', 'co2_cumulative_gkm', 'ect_c', 'egt_c', 'nh3_ppm', 'nox_mgs', 'nox_cumulative_mgkm', 'pm10_mgkm', 'velocity_kmh'],
          nox_mgs: {
            colors: ['#D3D3D3', '#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 2, 5, 20, 50]
          },
          nox_cumulative_mgkm : {
            colors: ['#669DF6'],
            steps: [0]
          },
          nh3_ppm: {
            colors: ['#D3D3D3', '#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 2, 10, 100, 300]
          },
          co2_gs: {
            colors: ['#D3D3D3', '#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 5, 15, 30, 60]
          },
          co2_cumulative_gkm : {
            colors: ['#669DF6'],
            steps: [0]
          },
          velocity_kmh: {
            colors: ['#D3D3D3', '#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 5, 60, 90, 160]
          },
          egt_c: {
            colors: ['#428bca', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 175, 200, 300]
          },
          ect_c: {
            colors: ['#428bca', '#FF0000'],
            steps: [0, 70]
          },
          pm10_mgkm: {
            colors: ['#D3D3D3', '#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 10, 15, 20, 25]
          }
        },
        {
          type: 'HD',
          attributes: ['co2_gs', 'co2_cumulative_gkm', 'ect_c', 'egt_c', 'nh3_ppm', 'nox_mgs', 'nox_gs', 'nox_over_co2', 'nox_per_kwh', 'pm10_mgkwh', 'velocity_kmh'],
          nox_per_kwh: {
            colors: ['#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 0.5, 1, 10]
          },
          nox_cumulative_mgkm : {
            colors: ['#669DF6'],
            steps: [0]
          },
          nh3_ppm: {
            colors: ['#32CD32', '#FFFF00', '#D3D3D3'],
            steps: [0, 10, 25]
          },
          co2_gs: {
            colors: ['#D3D3D3', '#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 5, 95, 130, 250]
          },
          co2_cumulative_gkm : {
            colors: ['#669DF6'],
            steps: [0]
          },
          velocity_kmh: {
            colors: ['#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 50, 75, 85]
          },
          egt_c: {
            colors: ['#428bca', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 175, 200, 300]
          },
          ect_c: {
            colors: ['#428bca', '#FF0000'],
            steps: [0, 70]
          },
          nox_over_co2: {
            colors: ['#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 0.7, 1, 10]
          },
          nox_mgs: {
            colors: ['#D3D3D3', '#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 50, 150, 500, 1000]
          },
          nox_gs: {
            colors: ['#D3D3D3', '#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 5, 15, 50, 100]
          },
          pm10_mgkwh: {
            colors: ['#D3D3D3', '#32CD32', '#FFFF00', '#FFA500', '#FF0000'],
            steps: [0, 10, 15, 20, 25]
          }
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Legend/script.js